import {ChangeDetectionStrategy, Component, Input} from '@angular/core';
import {MatExpansionModule} from '@angular/material/expansion';
import {ConnectionHelp} from './connection-help';

@Component({
  selector: 'app-connect-connection-help',
  standalone: true,
  imports: [MatExpansionModule],
  templateUrl: './connect-connection-help.component.html',
  styleUrl: './connect-connection-help.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ConnectConnectionHelpComponent {
  @Input({required: true}) guide!: ConnectionHelp;
  @Input() editing = false;
}
